
import { Component, Prop, Vue } from "vue-property-decorator";
import ticketAdministration from "@/views/Ticket/indexAdminis.vue";

@Component({
  name: "AllMyCreatedOrderLists",
  components: {
    ticketAdministration,
  },
})
export default class extends Vue {}
